const userInvitationStatuses = {
    pending: {},
    accepted: {}
};
Object.keys(userInvitationStatuses).forEach(key => {
    userInvitationStatuses[key].key = key;
});

export default userInvitationStatuses;
